const populateData = ({ commit, rootState }, tourData) => {
  const imgs = tourData.section_images.sort((a, b) => {
    if (a.filter_id === b.filter_id) {
      return parseInt(parseInt(a.imageset_id, 10) - parseInt(b.imageset_id, 10));
    }
    return parseInt(parseInt(a.filter_id, 10) - parseInt(b.filter_id, 10));
  });

  const slides = imgs.filter(img => img.type === 'team');

  commit('setSlides', slides);
};

export default {
  populateData,
};



// WEBPACK FOOTER //
// ./src/store/modules/builder/actions.js